@if(dataLoading()){<app-progress></app-progress>}
<div class="page-content">
  <div class="container-fluid">

    <!-- Page Title & Breadcrumb -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a routerLink="/admin/admin-dashboard">Dashboard</a>
              </li>
              <!-- <li class="breadcrumb-item active">{{ action().ParentMenuTitle }}</li> -->
              <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">

              <div class="row mb-2">

                <!-- New Hotel Button -->
                <div class="col-12 d-flex justify-content-end mb-2">
                  @if (action().CanCreate) {
                  <button mat-raised-button color="primary" (click)="openModal()">
                    New Hotel
                  </button>
                  }
                </div>

                <!-- Show Entries -->
                <div class="col-sm-12 col-md-4">
                  <div class="dataTables_length">
                    <label>Show
                      <select
                        class="custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                        [(ngModel)]="itemPerPage">
                        @for (option of PageSize; track option) {
                        <option [value]="option">{{ option }}</option>
                        }
                      </select> entries
                    </label>
                  </div>
                </div>

                <!-- Search -->
                <div class="col-sm-12 col-md-4 ms-auto">
                  <div class="dataTables_filter d-flex justify-content-end">
                    <label>Search:
                      <input type="search" class="form-control form-control-sm" placeholder="" [(ngModel)]="Search">
                    </label>
                  </div>
                </div>

              </div>

              <!-- Filter Row -->
              <div class="row mb-3">

                <!-- Filter Destination -->
                <div class="col-sm-12 col-md-3">
                  <label>Destination</label>
                  <select class="form-select" [(ngModel)]="FilterDestinationId"
                    (ngModelChange)="onFilterDestinationChange()">
                    <option value="0">-- Select Destinations --</option>
                    @for (dest of DestinationList(); track dest.DestinationId) {
                    <option [value]="dest.DestinationId">{{ dest.DestinationName }}</option>
                    }
                  </select>
                </div>

                <!-- Filter Location -->
                <div class="col-sm-12 col-md-3">
                  <label>Location</label>
                  <select class="form-select" [(ngModel)]="FilterLocationId" (ngModelChange)="onFilterLocationChange()"
                    [disabled]="FilterLocationList().length === 0">
                    <option value="0">-- Select Locations --</option>
                    @for (loc of FilterLocationList(); track loc.LocationId) {
                    <option [value]="loc.LocationId">{{ loc.LocationName }}</option>
                    }
                  </select>
                </div>

              </div>

              <!-- Table -->
              <div class="row">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table class="table table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      role="grid">
                      <thead>
                        <tr role="row">
                          <th>S.No</th>
                          <th style="cursor:pointer" (click)="sort('HotelName')">Hotel</th>
                          <th style="cursor:pointer" (click)="sort('DestinationName')">Destination</th>
                          <th style="cursor:pointer" (click)="sort('LocationName')">Location</th>
                          <th style="cursor:pointer" (click)="sort('HotelCategoryName')">Hotel Category</th>
                          <th style="cursor:pointer" (click)="sort('Status')">Status</th>
                          @if (action().CanEdit) { <th>Edit</th> }
                          @if (action().CanDelete) { <th>Delete</th> }
                        </tr>
                      </thead>
                      <tbody>
                        @for (
                        item of FilterHotelList()
                        | filter: Search
                        | orderBy: sortKey : reverse
                        | paginate: { itemsPerPage: itemPerPage, currentPage: p };
                        track item.HotelId;
                        let i = $index
                        ) {
                        <tr>
                          <td>{{ (itemPerPage * (p - 1)) + i + 1 }}</td>
                          <td>{{ item.HotelName }}</td>
                          <td>{{ item.DestinationName }}</td>
                          <td>{{ item.LocationName }}</td>
                          <td>{{ item.HotelCategoryName }}</td>
                          <td>
                            <span class="p-1" [ngClass]="item.Status == 1
                                  ? 'badge text-bg-success'
                                  : 'badge text-bg-danger'">
                              {{ AllStatusList[item.Status] }}
                            </span>
                          </td>
                          @if (action().CanEdit) {
                          <td>
                            <a class="text-success p-1" style="cursor:pointer" (click)="editHotel(item)">
                              <i class="bx bxs-edit-alt"></i>
                            </a>
                          </td>
                          }
                          @if (action().CanDelete) {
                          <td>
                            <a class="text-danger p-1" style="cursor:pointer" (click)="deleteHotel(item)">
                              <i class="bx bxs-trash"></i>
                            </a>
                          </td>
                          }
                        </tr>
                        }
                        @if (FilterHotelList().length === 0 && !dataLoading()) {
                        <tr>
                          <td colspan="8" class="text-center text-muted">
                            Select destination and location to view hotels
                          </td>
                        </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <div>
                  <pagination-controls (pageChange)="onTableDataChange($event)" style="float:right;"
                    class="my-pagination">
                  </pagination-controls>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal -->
  @if (showModal() && (action().CanEdit || action().CanCreate)) {
  <div class="modal fade show d-block" tabindex="-1" style="background:rgba(0,0,0,0.5)">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">

        <div class="modal-header">
          <h1 class="modal-title fs-5">
            @if (Hotel.HotelId > 0) { Update } @else { New } Hotel
          </h1>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>

        <div class="modal-body">
          <form #formHotel="ngForm">
            <div class="container">
              <div class="row">

                <!-- Destination -->
                <mat-form-field appearance="outline" class="col-sm-3">
                  <mat-label>Destination</mat-label>
                  <mat-select #DestinationId="ngModel" name="DestinationId" [(ngModel)]="Hotel.DestinationId"
                    (ngModelChange)="onDestinationChange()" required>
                    @for (dest of DestinationList(); track dest.DestinationId) {
                    <mat-option [value]="dest.DestinationId">{{ dest.DestinationName }}</mat-option>
                    }
                  </mat-select>
                  @if ((DestinationId.dirty || DestinationId.touched) ||
                  (DestinationId.invalid && isSubmitted)) {
                  <mat-error>Destination is <strong>required</strong></mat-error>
                  }
                </mat-form-field>

                <!-- Location -->
                <div class="col-sm-3" style="position: relative;">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Location</mat-label>
                    <mat-select #LocationId="ngModel" name="LocationId" [(ngModel)]="Hotel.LocationId" required>
                      @for (list of LocationList(); track list.LocationId) {
                      <mat-option [value]="list.LocationId">{{ list.LocationName }}</mat-option>
                      }
                    </mat-select>
                    @if ((LocationId.dirty || LocationId.touched) ||
                    (LocationId.invalid && isSubmitted)) {
                    <mat-error>Location is <strong>required</strong></mat-error>
                    }
                  </mat-form-field>

                  <!-- No location warning -->
                  @if (noLocationFound()) {
                  <div style="position:absolute; top:4px; left:0; right:0; z-index:1000;">
                    <div class="alert alert-warning py-2 mb-0" role="alert"
                      style="font-size:12px; padding:6px 10px !important; border-radius:6px;">
                      <i class="bx bx-info-circle me-1"></i>
                      No locations found for this destination.
                    </div>
                  </div>
                  }
                </div>

                <!-- Hotel Category -->
                <mat-form-field appearance="outline" class="col-sm-3">
                  <mat-label>Hotel Category</mat-label>
                  <mat-select #HotelCategoryId="ngModel" name="HotelCategoryId" [(ngModel)]="Hotel.HotelCategoryId"
                    required>
                    @for (list of HotelCategoryList(); track list.HotelCategoryId) {
                    <mat-option [value]="list.HotelCategoryId">{{ list.HotelCategoryName }}</mat-option>
                    }
                  </mat-select>
                  @if ((HotelCategoryId.dirty || HotelCategoryId.touched) ||
                  (HotelCategoryId.invalid && isSubmitted)) {
                  <mat-error>Hotel Category is <strong>required</strong></mat-error>
                  }
                </mat-form-field>

                <!-- Hotel Name -->
                <mat-form-field appearance="outline" class="col-sm-3">
                  <mat-label>Hotel Name</mat-label>
                  <input matInput #HotelName="ngModel" name="HotelName" [(ngModel)]="Hotel.HotelName" required
                    autofocus>
                  @if ((HotelName.dirty || HotelName.touched) ||
                  (HotelName.invalid && isSubmitted)) {
                  <mat-error>Hotel name is <strong>required</strong></mat-error>
                  }
                </mat-form-field>


                <!-- Hotel Contact Number -->
                <mat-form-field appearance="outline" class="col-sm-4">
                  <mat-label>Mobile No</mat-label>
                  <input type="tel" matInput #MobileNo="ngModel" name="MobileNo" [(ngModel)]="Hotel.HotelContactNumber"
                    maxlength="14" inputmode="numeric" placeholder="+91-XXXXXXXXXX"
                    (input)="onPhoneInput($event, 'HotelContactNumber')">
                </mat-form-field>

                 <!-- Hotel AlternateContactNumber -->
                <mat-form-field appearance="outline" class="col-sm-4">
                  <mat-label>Alternate No</mat-label>
                  <input type="tel" matInput #AlternateNo="ngModel" name="AlternateNo"
                    [(ngModel)]="Hotel.HotelAlternateContactNumber" maxlength="14" inputmode="numeric"
                    placeholder="+91-XXXXXXXXXX"
                    (input)="onPhoneInput($event, 'HotelAlternateContactNumber')">
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-sm-12">
                  <mat-label>Full Address</mat-label>
                  <textarea matInput #HotelAddress="ngModel" name="HotelAddress"
                    [(ngModel)]="Hotel.HotelAddress"></textarea>
                </mat-form-field>

                <!-- Status -->
                <mat-form-field appearance="outline" class="col-sm-3" style="height:15px;">
                  <mat-label>Status</mat-label>
                  <mat-select #Status="ngModel" name="Status" [(ngModel)]="Hotel.Status" required>
                    @for (status of StatusList; track status.Key) {
                    <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                    }
                  </mat-select>
                  @if ((Status.dirty || Status.touched) ||
                  (Status.invalid && isSubmitted)) {
                  <mat-error>Status is <strong>required</strong></mat-error>
                  }
                </mat-form-field>

                <!-- Logo -->
                <div class="col-sm-3">
                  <div class="card-body profile-card flex-column align-items-center">
                    <label>LOGO</label><br>
                    <img [src]="LogoPhoto ? LogoPhoto : 'assets/img/no-image.avif'" alt="Profile" class="img-responsive"
                      width="250">
                    <input type="file" accept="image/*" #LogoFile="ngModel" name="LogoFile"
                      (change)="setLogoFile($event)" [(ngModel)]="Hotel.HotelImage" class="form-control mt-2 mb-4">
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer mt-2">
          <button type="button" mat-raised-button color="warn" class="me-2" (click)="closeModal()">Cancel</button>
          <button mat-raised-button color="primary" (click)="saveHotel()">
            @if (Hotel.HotelId > 0) { Update } @else { Submit }
          </button>
        </div>

      </div>
    </div>
  </div>
  }

</div>